var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ShareIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 48,
    glyphOffsetY: -4
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 24L36.1078 48V36.0439C20.9994 32.9312 9.06459 36.3623 0 47.79C1.57368 24.2871 17.718 12.945 36.107 12.1942L36.1078 0L60 24Z"
  }));
};
export var ShareIconGlyph = function (props) {
  return React.createElement(ShareIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};